import logo from "../../image/logotype/logo.svg";
import logo1 from "../../image/goods.image/humates/agrobion.png";
import logo2 from "../../image/goods.image/humates/biocharm1.jpg";
import logo3 from "../../image/goods.image/humates/biacharm2.jpg";
import Button from "../../assets/Button/ButtonBuy/ButtonBuy"
import { Link } from "react-router-dom";

export const items = [
  {
    title: 'Агробіон',
    priceFirst: 'від 24 000 грн',
    unitFirst: "1т",
    InStock: true,
    producer: 'Санберрі Україна',
    logo: <img className="item__logo" src={logo} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={logo1} alt="logo" />,
    link: <Link to="order"><Button /></Link>,
    inside: "argobion",
    isNew: true,
    id: "1"
  },
  {
    title: 'Біочар IDEALE™ для городніх культур, кущів та дерев (2 л)',
    priceFirst: 'від 360 грн',
    unitFirst: "уп",
    InStock: true,
    producer: 'Санберрі Україна',
    logo: <img className="item__logo" src={logo} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={logo2} alt="logo" />,
    link: <Link to="order"><Button /></Link>,
    inside: "biochar2l",
    isNew: true,
    id: "2"
  },
  {
    title: 'Біочар IDEALE™ для кімнатних рослин та розсади (1,5 л)',
    priceFirst: 'від 300 грн',
    unitFirst: "уп",
    InStock: true,
    producer: 'Санберрі Україна',
    logo: <img className="item__logo" src={logo} alt="logo" />,
    imgUrl: <img className="itemCard__image" src={logo3} alt="logo" />,
    link: <Link to="order"><Button /></Link>,
    inside: "biochar15l",
    isNew: true,
    id: "3"
  }
];
